import React, { useEffect, useState, useMemo} from 'react'
import { useHistory } from 'react-router-dom'
import api from '../components/api';
import { sleep } from '../components/functions'
import { MDBDataTableV5 } from 'mdbreact';

import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

const AdesaoIndividual = () => {

    var [resultado, setResultado] = useState('')
    var [adesao_individual_id, setAdesaoIndividualId] = useState()
    

    const history = useHistory();
    
    useEffect(() => {


        if (adesao_individual_id) {

            history.push(`/AdesaoIndividual/${adesao_individual_id}`)

        }
        

    }, [adesao_individual_id])



    const columns = useMemo(
        () => [
          {
            accessorKey: 'dataISO', //access nested data with dot notation
            header: 'Adesão em',
          },
          {
            accessorKey: 'nome',
            header: 'Nome',
          },
          {
            accessorKey: 'nome_organizacao',
            header: 'Organização',
          },
          
          {
            accessorKey: 'municipio',
            header: 'Município',
          },

          {
            accessorKey: 'uf_codigo',
            header: 'UF',
          },
          

        ],
        [],
      );

    


    /*
    async function adesaoIndividualListaTodos() {

        await api.get('adesaoIndividualListaTodos').then((result) => {
            //console.log(result.data)


            setResultado(result.data.map((rs) => 

                <tr key={rs.adesao_individual_id} style={{ cursor: 'pointer'}} onClick={() => setAdesaoIndividualId(rs.adesao_individual_id)}>
                    <td>
                        {rs.dataISO}
                    </td>
                    <td>
                        {rs.nome}
                    </td>
                    
                    <td>
                        {rs.nome_organizacao}
                    </td>
                    <td>
                        {rs.municipio}
                    </td>
                    <td>
                        {rs.uf_codigo}
                    </td>
                    
                    
                </tr>

            ))

            //dataTableRender('dataTableExampleAU')

    


        }).catch((err) => {
            console.log(err.response)
        })

    }
    */


    function exportarExcel() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma exportar para Excel?',
		    buttons: {
		        Sim: function () {

                    window.toastr.info('Aguarde...')

                    api.get(`adesaoIndividualExcel`).then((result) => {

                        sleep(5000).then(() => {

                            //window.location.href = `http://apihomolog.hospitaissaudaveis.org/residuosSS.xlsx`
                            window.location.href = `https://api.hospitaissaudaveis.org/${result.data.arquivo}`
        
                        })

                        
                        //setEvento_id(data.evento_id)

                    }).catch((err) => {

                        console.log(err.response)

                    })

                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

        

    }


    async function adesaoIndividualListaTodos() {



        await api.get(`adesaoIndividualListaTodos`).then((result) => {

            setResultado(result.data.map((rs) => {
            
            return {

                dataISO: rs.dataISO,
                nome: rs.nome,
                nome_organizacao: rs.nome_organizacao,
                municipio: rs.municipio,
                uf_codigo: rs.uf_codigo,
                adesao_individual_id: rs.adesao_individual_id,
                //clickEvent: () => history.push(`AdesaoIndividual/${rs.adesao_individual_id}`)
                
            }

            }))



        }).catch((err) => {
            console.log(err.response)
        })

    }




    const data = {
        columns: [

            {
            label: 'Adesão em',
            field: 'dataISO',
            sort: 'asc',
            width: 270
            },

            {
                label: 'Nome',
                field: 'nome',
                sort: 'asc',
                width: 270
              },
          
          {
            label: 'Organização',
            field: 'nome_organizacao',
            sort: 'asc',
            width: 270
          },
          {
            label: 'Município',
            field: 'municipio',
            sort: 'asc',
            width: 200
          },
          {
            label: 'UF',
            field: 'uf_codigo',
            sort: 'asc',
            width: 100
          },
         
        ],
        rows: resultado
       
      };



    async function verificaPermissao() {


        if (sessionStorage.getItem('permAdesoes') != 'true') {

            history.push('/')

        }


    }


    useEffect(() => {

        verificaPermissao()
        adesaoIndividualListaTodos()

    }, [])


    return (

        <div>
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-add-user'></i>
                </div>
                <div class='header-title'>
                    <h1>Ades&atilde;o Individual</h1>
                    <small>Administração</small>
                    
                </div>
            </div>


            <div className="row">
                <div className="col-sm-12"  style={{ display: resultado ? 'block' : 'none'}}>
                    <div className="panel panel-bd lobidrag">
                        <div className="panel-heading" style={{ display: 'none'}}>
                            <div className="panel-title">
                                <h4>DataTables with HTML5 export buttons </h4>
                            </div>
                        </div>
                        <div class="panel-body">
                            
                            
                            <button type="button" class="btn btn-success" onClick={() => exportarExcel()}>Exportar XLSX</button>
                            <br/><br/>
                                
                                
                            
                            <MaterialReactTable 
                                
                                columns={columns} 
                                data={resultado} 
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{ 
                                    density: 'compact',
                                    pagination: {
                                                    pageSize: 15,
                                                    pageIndex: 0,
                                                },
                                    sorting: [
                                        {
                                          id: 'dataISO', //sort by age by default on page load
                                          desc: true,
                                        },
                                        
                                      ],
                                 }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                    fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                    },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                        xs: '8px',
                                        sm: '9px',
                                        md: '10px',
                                        lg: '11px',
                                        xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    //console.info(event, row.original.usuario_id);
                                    //navigate(`/FluxoCaixa/Vinculo/${row.original.vinculo_id}`)
                                    //window.$('.modal-MovimentoEdit').modal('show');setMovimento_id(row.original.movimento_id)
                                    
                                    history.push(`AdesaoIndividual/${row.original.adesao_individual_id}`)
                                    
            
                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                                })}
                            />

                            
                        </div>
                    </div>
                </div>
            </div>
        
            

        </div>

    )

}

export default AdesaoIndividual